import { useLayoutEffect, useState } from "react";
import { useAuth } from "../../../../hooks/useAuth";
import useInstitution from "../../../../hooks/useInstitution";
import LogoStore from "../../../../store/logo.store";
import { Avatar, Box } from "@mui/material";
import { compactMenuStyles, styles } from "../styles";
import Logo from "../../../../assets/images/zimba-logo.png";
import { USER_TYPES } from "../../../../constants/user-types";

export const IconSideBarHeader = () => {
  const { user }: any = useAuth();
  const business: any = useInstitution();
  const [logoState, setLogoState] = useState(LogoStore.initialState);

  useLayoutEffect(() => {
    const subscription = LogoStore.subscribe(setLogoState);
    LogoStore.init(business?.logo);

    return () => {
      subscription.unsubscribe();
    };
  }, [business?.logo]);

  const isRightUser = (requiredUsers?: string[]) => {
    if (!requiredUsers) return true;
    return requiredUsers.includes(user?.type);
  };

  return (
    <Box sx={styles.header}>
      <Box sx={compactMenuStyles.logoContainer}>
        <Avatar alt="Zimba Logo" src={Logo} />
      </Box>
      {!isRightUser([USER_TYPES.SYSTEM_USER]) && (
        <Box sx={compactMenuStyles.institutionLogoContainer}>
          <Avatar
            alt="Institution Logo"
            src={logoState.logo}
            variant="rounded"
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "white",
              padding: "2px",
            }}
          />
        </Box>
      )}
    </Box>
  );
};
